module.exports = __webpack_public_path__ + "img/cellar_grey.5780905c.svg";